import { createContext } from 'react';

const criticaContext = createContext();

export default criticaContext;